// extracted by mini-css-extract-plugin
module.exports = {"inTouch":"Header_inTouch__T6HLx","container":"Header_container__21wXn","logo":"Header_logo__3T0lc","duck":"Header_duck__1VEPp"};